const PWA_CACHE_PREFIX = 'silstech-srms-';

function addTenantManifest() {
  let manifest = document.querySelector('link[rel="manifest"]');
  if (!manifest) {
    manifest = document.createElement('link');
    manifest.rel = 'manifest';
    document.head.appendChild(manifest);
  }
  manifest.href = '/manifest.json?v=3';

  const metaValues = [
    ['mobile-web-app-capable', 'yes'],
    ['apple-mobile-web-app-capable', 'yes'],
    ['apple-mobile-web-app-status-bar-style', 'default'],
    ['apple-mobile-web-app-title', 'Silstech SRMS'],
    ['application-name', 'Silstech SRMS'],
  ];
  for (const [name, content] of metaValues) {
    let element = document.querySelector(`meta[name="${name}"]`);
    if (!element) {
      element = document.createElement('meta');
      element.name = name;
      document.head.appendChild(element);
    }
    element.content = content;
  }
}

function removePwaMetadata() {
  document.querySelectorAll('link[rel="manifest"]').forEach((element) => element.remove());
  [
    'mobile-web-app-capable',
    'apple-mobile-web-app-capable',
    'apple-mobile-web-app-status-bar-style',
    'apple-mobile-web-app-title',
    'application-name',
  ].forEach((name) => document.querySelector(`meta[name="${name}"]`)?.remove());
}

async function clearSrmsPwaState() {
  if ('serviceWorker' in navigator) {
    const registrations = await navigator.serviceWorker.getRegistrations();
    await Promise.all(registrations.map((registration) => registration.unregister()));
  }
  if ('caches' in window) {
    const names = await window.caches.keys();
    await Promise.all(
      names.filter((name) => name.startsWith(PWA_CACHE_PREFIX)).map((name) => window.caches.delete(name))
    );
  }
}

function observeUpdates(registration) {
  if (registration.waiting) {
    window.dispatchEvent(new CustomEvent('srms:pwa-update', { detail: { registration } }));
  }
  registration.addEventListener('updatefound', () => {
    const worker = registration.installing;
    if (!worker) return;
    worker.addEventListener('statechange', () => {
      if (worker.state === 'installed' && navigator.serviceWorker.controller) {
        window.dispatchEvent(new CustomEvent('srms:pwa-update', { detail: { registration } }));
      }
    });
  });
}

export async function configurePwaForHost({ tenantHost }) {
  // Development bundles reuse their URLs. Caching them can mix old React code
  // with new hot updates and leave local testing stuck in a reload loop.
  if (process.env.NODE_ENV === 'development') {
    await clearSrmsPwaState().catch((error) => {
      console.warn('Development PWA cleanup failed:', error);
    });
    return null;
  }
  if (!tenantHost) {
    removePwaMetadata();
    await clearSrmsPwaState().catch((error) => {
      console.warn('PWA cleanup failed:', error);
    });
    return null;
  }

  addTenantManifest();
  window.addEventListener('beforeinstallprompt', (event) => {
    event.preventDefault();
    window.__srmsDeferredInstallPrompt = event;
    window.dispatchEvent(new CustomEvent('srms:pwa-installable'));
  });
  window.addEventListener('appinstalled', () => {
    window.__srmsDeferredInstallPrompt = null;
    window.dispatchEvent(new CustomEvent('srms:pwa-installed'));
  });
  if (!('serviceWorker' in navigator)) return null;
  try {
    const registration = await navigator.serviceWorker.register('/service-worker.js', { scope: '/' });
    observeUpdates(registration);
    window.dispatchEvent(new CustomEvent('srms:pwa-ready', { detail: { registration } }));
    return registration;
  } catch (error) {
    console.warn('Silstech SRMS app service worker registration failed:', error);
    return null;
  }
}

export function activateWaitingServiceWorker(registration) {
  registration?.waiting?.postMessage({ type: 'SKIP_WAITING' });
}
